import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import InputField from '../InputField';
import _ from "lodash";

const SELECTOR_INPUT = 'input';
const CLICK_EVENT = 'click';

const HIDDEN_CLASS = 'u-hidden';

class AddressForm extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
        return `
            <div class="lta-address-form">
				<div class="lta-address-form-title u-hidden">${titleMarkup}</div>
                <div class="lta-address-form--address-form u-mb-2">
                    <div class="lta-address-form--mailing-street u-mb-3"></div>
                    <div class="lta-address-form--town u-mb-3"></div>
                    <div class="lta-address-form--county u-mb-3"></div>
                    <div class="lta-address-form--postcode u-mb-3"></div>
                </div>
            </div>
        `;
	}
	afterRender() { 
		this.addressFromSearchElement = SelectorEngine.findOne('.lta-address-form', this.containerEl);
        this.addressFromSearchForm = SelectorEngine.findOne('.lta-address-form--address-form', this.addressFromSearchElement);
        this.addressFromMailingStreet = SelectorEngine.findOne('.lta-address-form--mailing-street', this.addressFromSearchForm);
        this.addressFromTown = SelectorEngine.findOne('.lta-address-form--town', this.addressFromSearchForm);
        this.addressFromCounty = SelectorEngine.findOne('.lta-address-form--county', this.addressFromSearchForm);
        this.addressFromPostcode = SelectorEngine.findOne('.lta-address-form--postcode', this.addressFromSearchForm);
        this.addressObjects = [
            {
                inputElementData: this.addressFromMailingStreet,
                elementDataKey: 'mailingStreet'
            },
            {
                inputElementData: this.addressFromTown,
                elementDataKey: 'town'
            },
            {
                inputElementData: this.addressFromCounty,
                elementDataKey: 'county'
            },            
            {
                inputElementData: this.addressFromPostcode,
                elementDataKey: 'postcode'
            },
        ];
        this.initInputObject();
	}
    initInputObject() {
        let searchAddressObject = {};
        for (const addressObject of  this.addressObjects) {
            const inputFieldObject = new InputField(addressObject.inputElementData, {
                data: this.data[addressObject.elementDataKey]
            });
            addressObject.inputElement = inputFieldObject;
            inputFieldObject.onChange((dataObject) => {
                addressObject.value = dataObject.value;
                if(addressObject?.value?.length > 2 ) {
                    const valueObject = {
                        address: {
                            street: null,
                            city: null,
                            state: null
                        }
                    };
                    valueObject[addressObject.elementDataKey] = addressObject?.value;
                    searchAddressObject = {
                        ...searchAddressObject,
                        ...valueObject
                    }
                }

                if(_.size(searchAddressObject) === (this.addressObjects?.length + 1)) {
                    const finalObject = this.prepareAddressObject(searchAddressObject);
                    this.value = {
                        ...this.value,
                        ...finalObject
                    };
                }
            });
        }
    }
    prepareAddressObject(searchObject) {
        const modifyObject = {
            "address": {
                "postCode": searchObject.postcode,
                "mailingStreet": searchObject.mailingStreet,
                "mailingCity": searchObject.town,
                "county": searchObject.county,
                "addressCountry": "United Kingdom"
            }
         };
         return modifyObject;
    }
	validate() {
        for (const inputElementObject of this.addressObjects) {
            inputElementObject.inputElement.validate();
        }
	}
}
export default AddressForm;
